<button
    [class]="button?.classCss"
    @fadeInOut

    [disabled]="button?.disable"
    (click)="onAction()">
    <mat-icon *ngIf="button?.svgIcon" [svgIcon]="button?.svgIcon"></mat-icon>
    <span>{{ button?.title | translate }}</span>
</button>
